import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FirestoreService {
  constructor(
    private firestore: AngularFirestore
  ) { }
  // Crea un nuevo alumno
  // tslint:disable-next-line: max-line-length
  public createAlum(data: { nombre_alum: string, ape_pat_alum: string, ape_mat_alum: string, edad_alum: number, rut_alum: string, sexo_alum: string, nivel_educ: string }) {
    return this.firestore.collection('Alumnos').add(data);
  }
  // Obtiene un alumno
  public getAlum(documentId: string) {
    return this.firestore.collection('Alumnos').doc(documentId).snapshotChanges();
  }
  // Obtiene todos los alumnos
  public getAlums() {
    return this.firestore.collection('Alumnos').snapshotChanges();
  }
  // Actualiza un alumnos
  public updateAlum(documentId: string, data: any) {
    return this.firestore.collection('Alumnos').doc(documentId).set(data);
  }
  // Borra un alumnos
  public deleteAlum(documentId: string) {
    return this.firestore.collection('Alumnos').doc(documentId).delete();
  }

  // Crea un nuevo usuario ========Aqui nuevo usuario=======
  // tslint:disable-next-line: max-line-length
  public createUsuari(documentId: string, data: { nombre_usuar: string, ape_pat_usuar: string, ape_mat_usuar: string, edad_usuar: number, rut_usuar: string, correo_user: string, cargo_usuar: string, perfil_usuar: string }) {
    return this.firestore.collection('Usuarios').doc(documentId).set(data);
  }
  // Obtiene un usuario
  public getUsuari(documentId: string) {
    return this.firestore.collection('Usuarios').doc(documentId).snapshotChanges();
  }
  // Obtiene todos los Usuarios
  public getUsuaris() {
    return this.firestore.collection('Usuarios').snapshotChanges();
  }
  // Actualiza un usuario
  public updateUsuari(documentId: string, data: any) {
    return this.firestore.collection('Usuarios').doc(documentId).set(data);
  }
  // Borra un usuario
  public deleteUsuari(documentId: string) {
    return this.firestore.collection('Usuarios').doc(documentId).delete();
  }

  // Crea un nueva planificacion ========Aqui nuevas Planificaciones=======
  // tslint:disable-next-line: max-line-length
  public createPlanific(data: { ambito: string, nucleo: string, objetivo: string, observaciones: string }) {
    return this.firestore.collection('Planificaciones').add(data);
  }
  // Obtiene una planificacion
  public getPlanific(documentId: string) {
    return this.firestore.collection('Planificaciones').doc(documentId).snapshotChanges();
  }
  // Obtiene todas las planificaciones
  public getPlanifics() {
    return this.firestore.collection('Planificaciones').snapshotChanges();
  }
  // Actualiza una planificacion
  public updatePlanific(documentId: string, data: any) {
    return this.firestore.collection('Planificaciones').doc(documentId).set(data);
  }
  // Borra una planificacion
  public deletePlanific(documentId: string) {
    return this.firestore.collection('Planificaciones').doc(documentId).delete();
  }

  public createEvaluacObs(data: {nivel: string, observacion: string, fecha: number}) {
    return this.firestore.collection('EvaluacionesNivel').add(data);
  }


  public createEvaluac(data: { nivel: string,  alumno: string, educadora: string, ambito: string, nucleo: number,
                        objetivo: string, concepto: string, fecha: string, observacionesAlumno: string  }) {
    return this.firestore.collection('Evaluaciones').add(data);
  }

  public updateEvaluac(documentId: string, data: any) {
    return this.firestore.collection('Evaluaciones').doc(documentId).set(data);
  }

  public getAllData(document: string) {
    return this.firestore.collection(document).snapshotChanges();
  }

  public getData(document: string, documentId: string) {
    return this.firestore.collection(document).doc(documentId).snapshotChanges();
  }

  public deleteData(document: string, documentId: string) {
    return this.firestore.collection(document).doc(documentId).delete();
  }
}
